import { createSelector } from '@ngrx/store';
import { getAcronymFromName } from '../../data/partial/human-name.model';
import { Person } from '../../data/persons/person.model';
import { sessionInfoFeature, UserInfo } from '../reducers/session-info.reducer';
import { userPersonSelector } from './user-fhir.selectors';

export const userNameSelector = createSelector(
  sessionInfoFeature.selectUserInfo,
  userPersonSelector,
  (userInfo: UserInfo, userPerson: Person) =>
    userInfo?.name || userPerson?.name || userInfo?.preferred_username || '',
);

export const userFullNameSelector = createSelector(
  userPersonSelector,
  userNameSelector,
  (userPerson: Person, userName: string) =>
    userPerson?.nameDetails?.fullName || userName,
);

export const userAcronymSelector = createSelector(
  userPersonSelector,
  userNameSelector,
  (userPerson: Person, userName: string) =>
    userPerson?.acronym || getAcronymFromName(userName),
);

export const userBirthdateSelector = createSelector(
  userPersonSelector,
  (userPerson: Person) => userPerson?.birthdate,
);

export const userEmailSelector = createSelector(
  sessionInfoFeature.selectUserInfo,
  (userInfo: UserInfo) => userInfo?.email || '',
);

export const userContactEmailSelector = createSelector(
  userPersonSelector,
  userEmailSelector,
  (userPerson: Person, userEmail: string) =>
    userPerson?.contactDetails?.email || userEmail,
);

export const userAddressSelector = createSelector(
  userPersonSelector,
  (userPerson: Person) => userPerson?.address,
);

export const userAddressDetailsSelector = createSelector(
  userPersonSelector,
  (userPerson: Person) => userPerson?.addressDetails,
);

export const accountTerminationStatusSelector =
  sessionInfoFeature.selectAccountTerminationStatus;
